import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../stores/Hooks';
import { StatementStatusEnum } from '../models';

interface INavMenu
{
	/** Текущая закладка */
	CurrentPage: number,
}


export const NavMenu: React.FC<INavMenu> = observer(
	(
		// входные параметры компонента
		{ CurrentPage }: INavMenu
	) =>
	{
		const { uiState } = useStores();

		const myRef = React.useRef<any>();

		const handleClickOutside = (e:Event) => {
			if (myRef.current && !myRef.current.contains(e.target as Node)) {
				uiState.setIsHamburgerOpened(false);
			}
		};

		React.useEffect(() => {
			document.addEventListener('mousedown', handleClickOutside);
			return () => document.removeEventListener('mousedown', handleClickOutside);
		});

		function PageName(num:number):string
		{
			switch (num)
			{
				case 1: return "1. Регистрационные данные";
				case 2: return "2. Сведения об операторе ЭДО";
				case 3: return "3. Документы оператора ЭДО";
				case 4: return "4. Заявление оператора ЭДО";
				default: return "";
            }
		}

		return (
			<div className="steps-bar" ref={myRef}>
				<div className="menu-trigger">
					<button
						onClick={() => { uiState.setIsHamburgerOpened(!uiState.IsHamburgerOpened); }}
						className="btn btn-icon icon-delete close-menu">
						<svg width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" enableBackground="new 0 0 50 50" xmlSpace="preserve">
							<path fill="#1B2028" d="M8.667,15h30c0.552,0,1-0.447,1-1s-0.448-1-1-1h-30c-0.552,0-1,0.447-1,1S8.114,15,8.667,15z" />
							<path fill="#1B2028" d="M8.667,37h30c0.552,0,1-0.447,1-1s-0.448-1-1-1h-30c-0.552,0-1,0.447-1,1S8.114,37,8.667,37z" />
							<path fill="#1B2028" d="M8.667,26h30c0.552,0,1-0.447,1-1s-0.448-1-1-1h-30c-0.552,0-1,0.447-1,1S8.114,26,8.667,26z" />
						</svg>
					</button>
					<div className="current-menu-title ml-3">{PageName(CurrentPage)}</div>
				</div>
				<div className={"steps" + (uiState.IsHamburgerOpened?" open":"")}>
					<div className={"step" + (CurrentPage === 1 ? " active" : "") + (uiState.register.IsValid ? " complete" : "")}>
						<button
							type="button"
							className="step-btn"
							onClick={() => { uiState.changeActiveTab(1); }}
							disabled={uiState.DisabledTabs.indexOf(1) >= 0}
						>{PageName(1)}</button>
					</div>
					<div className={"step" + (CurrentPage === 2 ? " active" : "") + (uiState.info.IsValid ? " complete" : "")}>
						<button
							type="button"
							className="step-btn"
							onClick={() => { uiState.changeActiveTab(2); }}
							disabled={uiState.DisabledTabs.indexOf(2) >= 0}
						>{PageName(2)}</button>
					</div>
					<div className={"step" + (CurrentPage === 3 ? " active" : "") + (uiState.files.IsValid ? " complete" : "")}>
						<button
							type="button"
							className="step-btn"
							onClick={() => { uiState.changeActiveTab(3); }}
							disabled={uiState.DisabledTabs.indexOf(3) >= 0}
						>{PageName(3)}</button>
					</div>
					<div className={"step" + (CurrentPage === 4 ? " active" : "") + (uiState.StatementStatus === StatementStatusEnum.Received ? " complete" : "")}>
						<button
							type="button"
							className="step-btn"
							onClick={() => { uiState.changeActiveTab(4); }}
							disabled={uiState.DisabledTabs.indexOf(4) >= 0}
						>{PageName(4)}</button>
					</div>
				</div>
			</div>
		)
	}
)
